import { TherapistAction } from 'src/redux/actions/constant';

const initialState: object = {
  response: null,
  loading: false,
  error: null,
  success: false,
};

export const updateRecurringSeriesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TherapistAction.UPDATE_RECURRING_SERIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case TherapistAction.UPDATE_RECURRING_SERIES_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
        error: null,
        success: true,
      };
    case TherapistAction.UPDATE_RECURRING_SERIES_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        error: action.payload,
        success: false,
      };
    case TherapistAction.UPDATE_RECURRING_SERIES_RESET:
      return initialState;
    default:
      return state;
  }
};
